import React, { useState } from 'react';
import { RiLockPasswordLine, RiEyeLine, RiEyeOffLine, RiShieldKeyholeLine } from 'react-icons/ri';
import { toast } from 'react-toastify';
import grandstreamClient from '../../services/grandstreamClient';

const PbxAuthModal = ({ show, onHide, onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (!username.trim() || !password.trim()) {
      setErrorMsg('Please enter both PBX Username and Password.');
      return;
    }

    setLoading(true);

    try {
      // Demo / Testing Mode check for admin / Qcodes@123
      if (username.trim().toLowerCase() === 'admin' && password.trim() === 'Qcodes@123') {
        localStorage.setItem('pbx_cookie', 'mock_testing_cookie_admin');
        localStorage.setItem('pbx_demo_mode', 'true');
        sessionStorage.setItem('pbx_unlocked', 'true');
        toast.success('PBX Management Unlocked (Testing Demo Mode)!');
        setLoading(false);
        if (onSuccess) onSuccess();
        if (onHide) onHide();
        return;
      }

      // Live PBX Authentication
      localStorage.removeItem('pbx_demo_mode');
      const cookie = await grandstreamClient.loginWithCredentials(username.trim(), password.trim());

      if (cookie) {
        sessionStorage.setItem('pbx_unlocked', 'true');
        toast.success('PBX Management Unlocked Successfully!');
        setLoading(false);
        if (onSuccess) onSuccess();
        if (onHide) onHide();
      } else {
        setErrorMsg('Authentication failed: Invalid PBX Username or Password.');
        setLoading(false);
      }
    } catch (err) {
      setErrorMsg(err.message || 'PBX connection error. Ensure PBX is reachable at https://192.168.100.200:8089/api');
      setLoading(false);
    }
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ zIndex: 1050 }}
        onClick={onHide}
      ></div>

      {/* Modal Container */}
      <div 
        className="modal fade show d-block" 
        tabIndex="-1" 
        style={{ zIndex: 1055 }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '450px' }}>
          <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px' }}>
            
            {/* Header */}
            <div className="modal-header bg-primary text-white border-0 py-3" style={{ borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
              <div className="d-flex align-items-center gap-2">
                <RiShieldKeyholeLine size={24} className="text-warning" />
                <h5 className="modal-title fw-bold mb-0 text-white">PBX Management Access</h5>
              </div>
              <button 
                type="button" 
                className="btn-close btn-close-white" 
                aria-label="Close" 
                onClick={onHide}
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body p-4">
              <p className="text-muted small mb-4">
                Please enter your Grandstream PBX API credentials to unlock PBX Management features.
              </p>

              {errorMsg && (
                <div className="alert alert-danger py-2 px-3 small mb-3 rounded-2" role="alert">
                  {errorMsg}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label text-dark fw-semibold small">PBX Username</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <RiLockPasswordLine className="text-muted" />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0 ps-0"
                      placeholder="e.g. cdrapi"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      autoFocus
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="form-label text-dark fw-semibold small">PBX Password</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0">
                      <RiLockPasswordLine className="text-muted" />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control border-start-0 border-end-0 ps-0"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary border-start-0"
                      onClick={() => setShowPassword(!showPassword)}
                      tabIndex="-1"
                    >
                      {showPassword ? <RiEyeOffLine /> : <RiEyeLine />}
                    </button>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button 
                    type="button" 
                    className="btn btn-light px-4" 
                    onClick={onHide}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary px-4 d-inline-flex align-items-center gap-2"
                    disabled={loading}
                  >
                    {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                    {loading ? 'Authenticating...' : 'Unlock PBX'}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default PbxAuthModal;
